export default __webpack_public_path__ + "static/media/close_btn.9ac56470.svg";